<template>
  <el-menu
      background-color="#fff"
      text-color="#606266"
      active-text-color="#f95656"
      style="height: 100%; z-index: 99"
      :default-active="activeMenu"
      :collapse="isCollapse"
      :collapse-transition="false"
      router
  >
    <!-- Logo 作为特殊菜单项 -->
    <el-menu-item index="/" style="pointer-events: none;height: 50px;">
      <i class="el-icon-sugar" v-if="isCollapse" style="font-size: 24px;"></i>
      <span v-else class="logo-img">
        <img src="../assets/img/logo.png" style="width: 55px; height: 45px;margin-top: -8px">
      </span>
      <span slot="title" v-if="!isCollapse" class="logo-title">粉裙星物语</span>
    </el-menu-item>

    <!-- 其他菜单项 -->
    <el-menu-item index="/Home">
      <i class="el-icon-s-home"></i>
      <span slot="title">艺术之窗</span>
    </el-menu-item>

    <el-menu-item :index="'/'+item.menuclick" v-for="(item,i) in menu" :key="i">
      <i :class="item.menuicon"></i>
      <span slot="title">{{item.menuname}}</span>
    </el-menu-item>
  </el-menu>
</template>
<script>
    export default {
        name: "Aside",

        data(){
            return {
                //isCollapse:false

               /* menu:[
                    {
                        menuClick:'Admin',
                        menuName:'管路员管理',
                        menuIcon:'el-icon-s-custom'
                    },{
                        menuClick:'User',
                        menuName:'用户管理',
                        menuIcon:'el-icon-user-solid'
                    }
                ]*/
            }
        },
        computed:{
            "menu":{
                get(){
                    return this.$store.state.menu
                }
            },
            // 选中态跟随当前路由路径，进入/刷新个人中心等页面时高亮对应菜单项
            activeMenu(){
                return this.$route.path
            }
        },
        props:{

            isCollapse: {
              type: Boolean,
              default: false
            },


        }
    }
</script>

<style scoped>
@font-face {
  font-family: '爱心字体';
  src: url('../assets/fonts/爱心字体.ttf') format('truetype');
}
.logo-img {
  margin-left: -10px;
}



.logo-title {
  font-family: '爱心字体';
  font-size: 16px;
  font-weight: bold;
  color: #ee89b7;
}


</style>
